// extracted by mini-css-extract-plugin
module.exports = {"Input":"AuthInput_Input__1PBf0","Label":"AuthInput_Label__1M6FQ","InputElement":"AuthInput_InputElement__1hp2h","Invalid":"AuthInput_Invalid__YGPth"};